"use client"
/* */
import { useLocalizedStringFormatter } from 'react-aria';
import locales from '../../../../../_virtual/_.locale.json@8b26c19d587a90f821a2307c8122f6d1.mjs';
import { useEffect } from 'react';
import { useLiveRegion } from '@chakra-ui/live-region';

const useAriaAnnounceActionState = (actionState, options = {}) => {
  const formater = useLocalizedStringFormatter(locales);
  const {
    isPendingText = formater.format("action.isPending"),
    isSucceededText = formater.format("action.isSucceeded"),
    isFailedText = formater.format("action.isFailed")
  } = options;
  const liveRegion = useLiveRegion({
    "aria-live": "polite",
    "aria-atomic": false,
    "aria-relevant": "text additions",
    role: "status"
  });
  useEffect(() => {
    if (actionState === "isPending") {
      liveRegion.speak(isPendingText);
    } else if (actionState === "isSucceeded") {
      liveRegion.speak(isSucceededText);
    } else if (actionState === "isFailed") {
      liveRegion.speak(isFailedText);
    }
  }, [actionState]);
};

export { useAriaAnnounceActionState };
//# sourceMappingURL=ariaLive.mjs.map
